import CategoryList from "../../slices/master/category/CategoryList";
import CategoryDetails from "../../slices/master/category/CategoryDetails";
import BlockList from "../../slices/master/block/BlockList";
import BlockDetails from "../../slices/master/block/BlockDetails";
import DepartmentList from "../../slices/master/department/DepartmentList";
import DepartmentDetails from "../../slices/master/department/DepartmentDetails";
import ServiceDepartmentList from "../../slices/master/service_department/ServiceDepartmentList";
import ServiceDepartmentDetails from "../../slices/master/service_department/ServiceDepartmentDetails";
import ItemCategoryList from "../../slices/master/item_category/ItemCategoryList";
import ItemCategoryDetails from "../../slices/master/item_category/ItemCategoryDetails";
import ItemList from "../../slices/master/item/ItemList";
import ItemDetails from "../../slices/master/item/ItemDetails";
import LocationList from "../../slices/master/location/LocationList";
import BrandList from "../../slices/master/brand/BrandList";
import BrandDetails from "../../slices/master/brand/BrandDetails";
import SkillMatrixList from "../../slices/master/skill_matrix/SkillMatrixList";
import SkillMatrixDetails from "../../slices/master/skill_matrix/SkillMatrixDetails";
import InventoryUnitList from "../../slices/master/inventory_unit/InventoryUnitList";
import InventoryUnitDetails from "../../slices/master/inventory_unit/InventoryUnitDetails";
import TaskStatusList from "../../slices/master/task_status/TaskStatusList";
import TaskStatusDetails from "../../slices/master/task_status/TaskStatusDetails";
import SlaAndPriorityList from "../../slices/master/sla_and_priority/SlaAndPriorityList";
import SlaAndPriorityDetails from "../../slices/master/sla_and_priority/SlaAndPriorityDetails";
import StaffList from "../../slices/master/staff/StaffList";
import StaffDetails from "../../slices/master/staff/StaffDetails";
import SubCategoryDetails from "../../slices/master/subcategory/SubCategoryDetails";
import SubCategoryList from "../../slices/master/subcategory/SubCategoryList";
import SubCategoryByCategory from "../../slices/master/subcategory/SubCategoryByCategory";
import SubLocationList from "../../slices/master/sub_location/SubLocationList";
import VendorList from "../../slices/master/vendor/VendorList";
import LocationByBlock from "../../slices/master/location/LocationByBlock";
import SubLocationByLocation from "../../slices/master/sub_location/SubLocationByLocation";
import SparePartsList from "../../slices/master/spare_parts/SparePartsList";
import SparePartsDetails from "../../slices/master/spare_parts/SparePartsDetails";
import ToolsList from "../../slices/master/tools/ToolsList";
import ToolsDetails from "../../slices/master/tools/ToolsDetails";
import ShiftList from "../../slices/master/shift/ShiftList";
import ShiftDetails from "../../slices/master/shift/ShiftDetails";
import ReasonList from "../../slices/master/reason/ReasonList";
import ReasonDetails from "../../slices/master/reason/ReasonDetails";
import locationDetails from "../../slices/master/location/LocationDetails";
import subLocationDetails from "../../slices/master/sub_location/SubLocationDetails";
import vendorDetails from "../../slices/master/vendor/VendorDetails";
import CountryList from '../../slices/master/country/CountryList'
import CountryDetails from "../../slices/master/country/CountryDetails"
import StateList from '../../slices/master/state/StateList'
import StateDetails from '../../slices/master/state/StateDetails'
import StatebyCountry from '../../slices/master/state/StatebyCountry'
import CityList from "../../slices/master/city/CityList";
import CityDetails from "../../slices/master/city/CityDetails";
import CitybyState from "../../slices/master/city/CitybyState";
import ItemPartsList from "../../slices/master/item/ItemPartsList";
import ItemToolList from "../../slices/master/item/ItemToolList";
import MasterChecklistList from "../../slices/master/master_checklist/MasterChecklistList";
import MasterChecklistDetails from "../../slices/master/master_checklist/MasterChecklistDetails";
import ProductMachineList from "../../slices/production_management/ProductMachineList";
import MachineProductList from "../../slices/production_management/MachineProductList";
import MachineProductDetails from "../../slices/production_management/MachineProductDetails";
import ProductMachineOee from "../../slices/production_management/ProductMachineOee";

const masterReducer = {
    categoryList: CategoryList,
    categoryDetails: CategoryDetails,
    blockList: BlockList,
    blockDetails: BlockDetails,
    departmentList: DepartmentList,
    departmentDetails: DepartmentDetails,
    serviceDepartmentList: ServiceDepartmentList,
    serviceDepartmentDetails: ServiceDepartmentDetails,
    itemCategoryList: ItemCategoryList,
    itemCategoryDetails: ItemCategoryDetails,
    itemList: ItemList,
    // sparePartsList: SparePartsList,
    itemDetails: ItemDetails,
    locationList: LocationList,
    locationDetails: locationDetails,
    locationByBlock: LocationByBlock,
    subLocationByLocation: SubLocationByLocation,
    vendorList: VendorList,
    vendorDetails: vendorDetails,

    // shudhanshu-----------------------------

    brandList: BrandList,
    brandDetails: BrandDetails,
    skillMatrixList: SkillMatrixList,
    skillMatrixDetails: SkillMatrixDetails,
    inventoryUnitList: InventoryUnitList,
    inventoryUnitDetails: InventoryUnitDetails,
    taskStatusList: TaskStatusList,
    taskStatusDetails: TaskStatusDetails,
    slaAndPriorityList: SlaAndPriorityList,
    slaAndPriorityDetails: SlaAndPriorityDetails,
    staffList: StaffList,
    staffDetails: StaffDetails,
    subLocationList: SubLocationList,
    subLocationDetails: subLocationDetails,
    subCategoryList: SubCategoryList,
    subCategoryDetails: SubCategoryDetails,
    subCategoryByCategory: SubCategoryByCategory,
    sparePartsList: SparePartsList,
    sparePartsDetails: SparePartsDetails,
    toolsList: ToolsList,
    toolsDetails: ToolsDetails,
    shiftList: ShiftList,
    shiftDetails: ShiftDetails,
    reasonList: ReasonList,
    reasonDetails: ReasonDetails,
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    cityList: CityList,
    cityDetails: CityDetails,
    citybyState: CitybyState,
    itemPartsList: ItemPartsList,
    itemToolList: ItemToolList,
    masterChecklistList: MasterChecklistList,
    masterChecklistDetails: MasterChecklistDetails,
    productMachineList: ProductMachineList,
    machineProductList: MachineProductList,
    machineProductDetails: MachineProductDetails,
    productMachineOee: ProductMachineOee,
    };

export default masterReducer;